import * as types from '../const/action.types';

export function proccess(
    state = {
        id: 0,
        param: undefined,
        title: 'iFlares',
        prominent: true,
        back: false,
        search: false,
        filter: false,
        appbar: false,
    },
    action,
) {
    switch (action.type) {
        case types.SET_WINDOW:
            return {
                id: action.value,
                param: action.param,
                title: action.title,
                prominent: action.prominent,
                back: action.back,
                search: action.search,
                filter: action.filter,
            };

        case types.SET_PROMINENT_TOOLBAR:
            return {
                id: state.id,
                param: state.param,
                title: state.title,
                prominent: action.value,
                back: state.back,
                search: state.search,
                filter: state.filter,
            };

        case types.SET_SEARCH:
            return {
                id: state.id,
                param: state.param,
                title: state.title,
                prominent: state.prominent,
                back: state.back,
                search: action.search,
                filter: state.filter,
            };
        case types.SET_APP_BAR:
            return {
                id: state.id,
                param: state.param,
                title: state.title,
                prominent: state.prominent,
                back: state.back,
                search: state.search,
                filter: state.filter,
                appbar: action.show,
            };
        default:
            return state;
    }
}

export function filter(state = {}, action) {
    switch (action.type) {
        case types.SET_FILTER:
            state[action.window] = action.filter;
            return state;
        default:
            return state;
    }
}

export function tools(state = [], action) {
    switch (action.type) {
        case types.SET_TOOLS:
            return action.components;
        default:
            return state;
    }
}

export function searchArray(state = [], action) {
    switch (action.type) {
        case types.SET_SEARCH:
            return [];
        case types.SET_SEARCH_ARRAY:
            return [...action.values];
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/process.home.reducer.js